import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getCPInternacionales,
  updateCPInternacional,
  insertCPInternacional,
  deleteCPInternacional,
} from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_CP_INTERNACIONALES(action) {
  try {
    const cpInterData = yield call(getCPInternacionales, action.payload)
    if (cpInterData.ok) {
      yield put({
        type: actions.CP_INTERNACIONALES_LOAD_SUCCEEDED,
        payload: cpInterData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Códigos postales Internacionales')
      put({
        type: actions.CP_INTERNACIONALES_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CP_INTERNACIONALES_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_CP_INTERNACIONAL(action) {
  try {
    const cpInterObj = yield call(insertCPInternacional, action.payload)
    if (cpInterObj.ok) {
      putMessage(messageType.SUCCESS, 'Código postal Internacional creado correctamente')
      yield put({
        type: actions.CP_INTERNACIONAL_INSERT_SUCCEEDED,
        payload: cpInterObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Código postal Internacional')
      yield put({
        type: actions.CP_INTERNACIONAL_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Código postal Internacional')
    yield all([
      put({
        type: actions.CP_INTERNACIONAL_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_CP_INTERNACIONAL(action) {
  try {
    const cpInterObj = yield call(updateCPInternacional, action.payload)
    if (cpInterObj.ok) {
      putMessage(messageType.SUCCESS, 'Código postal Internacional modificado correctamente')
      yield put({
        type: actions.CP_INTERNACIONAL_UPDATE_SUCCEEDED,
        payload: cpInterObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Código postal Internacional')
      yield put({
        type: actions.CP_INTERNACIONAL_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Código postal Internacional')
    yield all([
      put({
        type: actions.CP_INTERNACIONAL_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_CP_INTERNACIONAL(action) {
  try {
    const cpInterResult = yield call(deleteCPInternacional, action.payload)
    if (cpInterResult.ok) {
      putMessage(messageType.SUCCESS, 'Código postal Internacional eliminado correctamente')
      yield put({
        type: actions.CP_INTERNACIONAL_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Código postal Internacional')
      yield put({
        type: actions.CP_INTERNACIONAL_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Código postal Internacional')
    yield all([
      put({
        type: actions.CP_INTERNACIONAL_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.CP_INTERNACIONALES_LOAD_REQUESTED, GET_CP_INTERNACIONALES),
    takeEvery(actions.CP_INTERNACIONAL_INSERT_REQUESTED, INSERT_CP_INTERNACIONAL),
    takeEvery(actions.CP_INTERNACIONAL_UPDATE_REQUESTED, UPDATE_CP_INTERNACIONAL),
    takeEvery(actions.CP_INTERNACIONAL_DELETE_REQUESTED, DELETE_CP_INTERNACIONAL),
  ])
}
